import { ref } from 'vue';

export function useNotifications() {
  const notifications = ref([]);
  let notificationId = 0;

  const showNotification = ({ title, message, type = 'info', duration = 4000, actions = [] }) => {
    const id = ++notificationId;
    const notification = {
      id,
      title,
      message,
      type,
      actions,
      visible: true
    };
    
    notifications.value.push(notification);
    
    // Auto-remove after duration
    if (duration > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, duration);
    }
    
    return id;
  };
  
  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id);
    if (index > -1) {
      notifications.value.splice(index, 1);
    }
  };
  
  const clearAllNotifications = () => {
    notifications.value = [];
  };
  
  const getNotificationIcon = (type) => {
    const icons = {
      info: 'mdi:information',
      success: 'mdi:check-circle',
      warning: 'mdi:alert',
      error: 'mdi:alert-circle'
    };
    return icons[type] || icons.info;
  };

  // Make showNotification available globally for the composable
  if (typeof window !== 'undefined') {
    window.showNotification = showNotification;
  }

  return {
    notifications,
    showNotification,
    removeNotification,
    clearAllNotifications,
    getNotificationIcon
  };
} 